import classNames from 'classnames';
import React from 'react';

const Chip = ({ text, fullwidth, className }) => {
  return (
    <div
      className={classNames(
        className,
        'flex items-center w-full  text-primary label space-x-4',
        fullwidth ? 'max-w-auto' : 'max-w-[300px]',
      )}
    >
      <hr className="border-primary w-full rounded border-[1.5px] " />
      <span className="max-w-max min-w-max inline-block">
        {text}
      </span>
      <hr className="border-primary w-full rounded border-[1.5px] " />
    </div>
  );
};

export default Chip;
